/*
 *
 * MapPage constants
 *
 */

export const MAP_MOVED = 'app/MapPage/MAP_MOVED';
export const MAP_CHANGEDTYPE = 'app/MapPage/MAP_CHANGEDTYPE';
export const MAP_CHANGEDMODE = 'app/MapPage/MAP_CHANGEDMODE';
